import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Swal from 'sweetalert2';
import api3000 from '../../services/api3000';

// Animação de entrada (fade + scale)
const fadeScaleIn = keyframes`
  0% { opacity: 0; transform: scale(0.7); }
  100% { opacity: 1; transform: scale(1); }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 25px 30px;
  width: 500px;
  max-width: 90%;
  animation: ${fadeScaleIn} 0.3s ease-out;
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
`;

const Title = styled.h2`
  margin-bottom: 20px;
  text-align: center;
`;

const Input = styled.input`
  width: 80%;   
  margin: 0 auto 15px auto; 
  display: block;
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    border-color: #3085d6;
    outline: none;
    box-shadow: 0 0 0 2px rgba(51, 153, 255, 0.2);
  }
`;


const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
`;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease;
  background: ${(props) => (props.primary ? '#3085d6' : '#dcdcdc')};
  color: ${(props) => (props.primary ? '#fff' : '#000')};

  &:hover { opacity: 0.9; transform: translateY(-1px); }
  &:active { transform: translateY(0); opacity: 0.8; }
`;

const PasswordUpdateModal = ({ userId, onClose, onUpdated }) => {
  const [novaSenha, setNovaSenha] = useState('');

  const handleUpdate = async () => {
    try {
      if (!novaSenha) {
        Swal.fire({ icon: 'warning', title: 'Informe a nova senha.' });
        return;
      }
      if (novaSenha.length < 8) {
        Swal.fire({ icon: 'error', title: 'Erro', text: 'A senha deve ter pelo menos 8 caracteres.' });
        return;
      }

      const token = localStorage.getItem('token');
      await api3000.put(`/api/users/${userId}/password`, { senha: novaSenha }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      Swal.fire({ icon: 'success', title: 'Senha atualizada com sucesso!', showConfirmButton: false, timer: 1800 });
      onUpdated();
      onClose();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message || 'Erro ao atualizar senha.' });
    }
  };

  return (
    <Overlay>
      <Modal>
        <Title>Alterar Senha</Title>
        <Input
          type="password"
          placeholder="Nova senha"
          value={novaSenha}
          onChange={e => setNovaSenha(e.target.value)}
          maxLength={255}
        />
        <ButtonRow>
          <Button type="button" onClick={onClose}>Cancelar</Button>
          <Button type="button" primary onClick={handleUpdate}>Atualizar</Button>
        </ButtonRow>
      </Modal>
    </Overlay>
  );
};

export default PasswordUpdateModal;
